import React from 'react';
import {
  Card,
} from 'react-bootstrap';

const CompletedApplication = () => {
  return(
    <Card className='completed-application'>
      <Card.Body>
        <Card.Title className="text-center bold">
          Application Submitted
        </Card.Title>
        <Card.Text className="text-center sub-text bold">
        </Card.Text>
        <div className='text-center'><i className="fas fa-check-circle text-center"></i></div>
        <div className='body-text text-center'>
          Your application was successfully submitted. A member of our team will be in touch soon
        </div>
      </Card.Body>
    </Card>
  )
}

export default CompletedApplication;